import { CanDeactivateFn } from "@angular/router";
import { ManagerGoalSettingComponent } from "./manager-goal-setting.component";

/**
 * CanDeactivate guard per la pagina Manager Goal Setting.
 *
 * Se ci sono modifiche pending non condivise (fase Aggiornamento, doc cap. 9), apre la modale
 * "Modifiche non salvate" e attende la scelta dell'utente: Annulla blocca la navigazione,
 * Esci senza condividere la consente e scarta le modifiche.
 */
export const managerGoalSettingCanDeactivate: CanDeactivateFn<ManagerGoalSettingComponent> =
  (component) => component.guardPendingChanges();
